module.exports = __webpack_public_path__ + "static/media/15b-01-HOME_Serie-blanca-1-2015-200x300cm-oleo-sobre-papel.jpg.04fe6a57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15b/15b-01-HOME_Serie-blanca-1-2015-200x300cm-oleo-sobre-papel.jpg.jpg
// module id = 158
// module chunks = 0